import React, { useState, useEffect, forwardRef, InputHTMLAttributes, useCallback } from 'react';
import { Button, Card, CardBody, Col, Container, Input, InputGroup, Label, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row, UncontrolledTooltip } from 'reactstrap';
import { ChevronLeft, ChevronRight, Download, Eye, Trash2, FileText, Edit } from 'react-feather';
import Swal from 'sweetalert2';
import webservice from '../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import DataTable from 'react-data-table-component';
import { saveAs } from 'file-saver'
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../ReaduxToolkit/Hooks';
import ReactPaginate from 'react-paginate';
import { getData, Get_permission } from './store';
import moment from "moment-timezone";
import websocket_webservice from '../../../Service/websocket_webservice'
import { Document, Packer, Paragraph, TextRun } from "docx";
import api from '../../../api';

// Shared offscreen canvas for text-width measurement (created lazily, reused across calls).
let previewMeasureCtx: CanvasRenderingContext2D | null | undefined;
function measurePreviewTextWidth(text: string, fontSizePx: number, fontFamily?: string): number {
  if (previewMeasureCtx === undefined) {
    const canvas = document.createElement('canvas');
    previewMeasureCtx = canvas.getContext('2d');
  }
  if (!previewMeasureCtx) return text.length * fontSizePx * 0.6;
  previewMeasureCtx.font = `${fontSizePx}px ${fontFamily || 'Calibri, sans-serif'}`;
  return previewMeasureCtx.measureText(text).width;
}

// Template preview boxes are sized to fit the short real answer a field will eventually hold
// (e.g. "Yes", "$500"), not the much longer "$fieldKey$" placeholder shown before any patient
// is attached. Rather than silently clipping that placeholder (native <input> hides overflow
// with no ellipsis at all), shrink the font just enough for it to fit the box, down to a floor
// that stays legible.
function fitPreviewFontSize(text: string, baseFontSize: number, availableWidthPx: number, fontFamily?: string, minFontSize = 5): number {
  if (!text || availableWidthPx <= 0) return baseFontSize;
  const measured = measurePreviewTextWidth(text, baseFontSize, fontFamily);
  if (measured <= availableWidthPx) return baseFontSize;
  return Math.max(minFontSize, baseFontSize * (availableWidthPx / measured));
}

const CustomHeader = ({ menuActions, handleFilter, value, handlePerPage, rowsPerPage, activeTab }: any) => {
  return (
    <div className='client-master-list-table-header w-100 py-2'>
      <Row>
        <Col lg='6' className='d-flex align-items-center px-0 px-lg-1'>
          <div className='d-flex align-items-center me-4 '>
            <label htmlFor='rows-per-page' className='me-2'>Rows per Page:</label>
            <Input
              type='select'
              id='rows-per-page'
              value={rowsPerPage}
              onChange={handlePerPage}
              className='form-control ms-50 larger-select '
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
            </Input>
          </div>
          {menuActions.includes('add') && activeTab === 'document' && (
            <Button tag={Link} to='/templateCreation/newTemplateCreation' color='primary' className='ms-2 zoom-on-hover'>
              + Create New Template
            </Button>
          )}
          {menuActions.includes('add') && activeTab === 'form' && (
            <Button tag={Link} to='/templateCreation/formDesigner' color='primary' className='ms-2 zoom-on-hover'>
              + Create Form Template
            </Button>
          )}
        </Col>
        <Col
          lg='6'
          className='d-flex align-items-center justify-content-lg-end mt-lg-0 mt-1 px-0 px-lg-3'
        >
          <InputGroup className="input-group-search mb-2 zoom-on-hover">
            <Input
              type="text"
              placeholder="🔍 Search...."
              value={value}
              onChange={(e) => handleFilter(e.target.value)}
              className="input-search"
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

const TemplateCreationWithForm: React.FC = () => {
  interface DeleteRowData {
    id: string;
    User_Name: string;
    ClientName: string;
    file_name: string;
    refid: string;
    content_time: string;
    UserName: string;
  }


  const [data, setData] = useState<DeleteRowData[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  const usertype = localStorage.UserType;
  const id = usertype === 'MOS' ? localStorage.id : localStorage.ClientId;

  const store = useSelector((state: any) => state.Template)

  const navigate = useNavigate();
  const [value, setValue] = useState<string>('');
  // Coming back from the Form Designer lands on the Form tab; everything else opens the template tab
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'document' | 'form'>(
    (location.state as { tab?: string } | null)?.tab === 'form' ? 'form' : 'document'
  );
  const [sort, setSort] = useState<string>('');
  const [sortColumn, setSortColumn] = useState<any>('short_the_date'); // Example initial sort column
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  // const menuActions = ['add', 'delete'];
  const dispatch = useAppDispatch()
  const [eventId, setEventId] = useState<DeleteRowData[]>([]);
  const [eventId1, setEventId1] = useState(0);
  const selectedRowsPerPage: { [key: number]: DeleteRowData[] } = {};
  const action = { fromUser: true };
  const [scrollInnerModal, setScrollInnerModal] = useState<boolean>(false);
  const [refid, setRefid] = useState<string | null>(null);
  const [filteredAuditData, setFilteredAuditData] = useState<any[]>([]);
  const [menuActions, setMenuActions] = useState<string>('');
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileName, setPreviewFileName] = useState('');
  const [previewContent, setPreviewContent] = useState('');
  const [previewLayoutSchema, setPreviewLayoutSchema] = useState<any>(null);


  useEffect(() => {
    if (localStorage.id !== null) {
      dispatch(Get_permission(localStorage.id)).then((response) => {
        const res1 = response.payload;
        const Action = res1[0].Permission.filter(
          (item: any) => item.MenuKey === "TEMPLATECREATION"
        );
        setMenuActions(Action[0].MenuActions);
      });
    }
  }, [localStorage.id])


  const [localData, setLocalData] = useState<DeleteRowData[]>(store.data);
  // 1. Define fetchData function outside useEffect (optional but clean)
  const templateType = activeTab === 'form' ? 'designer' : 'document';

  const fetchData = async () => {
    try {
      const actionResult = await dispatch(
        getData({
          q: value,
          perPage: rowsPerPage,
          page: currentPage,
          sort,
          sortColumn,
          templateType,
        })
      );
      const payload = actionResult.payload as { data: DeleteRowData[] };
      setLocalData(payload.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // 2. useEffect for fetching initial data
  useEffect(() => {
    fetchData();
  }, [dispatch, rowsPerPage, currentPage, sort, sortColumn, value, templateType]);

  const handleTabChange = (tab: 'document' | 'form') => {
    if (tab === activeTab) return;
    setActiveTab(tab);
    setValue('');
    setCurrentPage(1);
    setEventId([]);
    setEventId1(0);
  };

  // 3. useEffect for WebSocket connection
  useEffect(() => {
    const socket = new WebSocket(`${websocket_webservice}ws/Tempalatedata/`);

    socket.onmessage = (event) => {
      const change = JSON.parse(event.data);

      setLocalData((prevData: DeleteRowData[]) =>
        prevData.map((item) =>
          item.id === change.documentKey._id.$oid
            ? { ...item, ...change.updateDescription.updatedFields }
            : item
        )
      );
    };

    return () => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [websocket_webservice]);



  const handleReloadTable = () => {
    dispatch(
      getData({
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn,
        templateType,
      })
    );
  };

  const handleFilter = (val: any) => {
    setValue(val)
    setCurrentPage(1)
    dispatch(
      getData({
        q: val,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn,
        templateType,
      })
    )
  }

  const handlePerPage = (e: any) => {
    dispatch(
      getData({
        q: value,
        perPage: parseInt(e.target.value),
        page: currentPage,
        sort,
        sortColumn,
        templateType,
      })
    )
    setRowsPerPage(parseInt(e.target.value))
  }

  const handlePagination = (page: any) => {
    dispatch(
      getData({
        q: value,
        perPage: rowsPerPage,
        page: page.selected + 1,
        sort,
        sortColumn,
        templateType,
      })
    )
    setCurrentPage(page.selected + 1)
  }

  const dataToRender = () => {
    const filters: any = {
      q: value
    };
    const isFiltered = Object.keys(filters).some(function (k) {
      return filters[k].length > 0;
    });

    if (localData.length > 0) {
      return localData;
    } else if (localData.length === 0 && isFiltered) {
      return [];
    } else {
      return store.allData.slice(0, rowsPerPage);
    }
  };


  const handleSort = (column: any, sortDirection: any) => {
    setSort(sortDirection)
    setSortColumn(column.sortField)
    dispatch(
      getData({
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort: sortDirection,
        sortColumn: column.sortField,
        templateType,
      })
    )
  }

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.total / rowsPerPage))

    return (
      <ReactPaginate
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="..."
        pageCount={count || 1}
        onPageChange={handlePagination}
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
      />
    )
  }
  const getAuditlogdata = async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, data);
    const response = await api.fetch('api/TemplateCreation/getAuditLogData', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key, response);
    return TempData;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (refid !== null) {
        const res = await getAuditlogdata(refid);

        setFilteredAuditData(res);
      }
    };
    fetchData();
  }, [refid]);


  const DownloadAuditLogdata = async (Data: any) => {
    // const EncParams = AesEncrypt(Data);
    await api.fetch('api/TemplateCreation/DownloadAuditLogdata', {
      method: 'POST',
      body: JSON.stringify({ Data })
    });
  };


  const DownloadTemplate = async (row: any) => {
    const Id = row.id;
    const Username = localStorage.UserName;
    const Name = row.file_name;
    const RefId = row.refid;
    const Data = { Username, RefId, Name };

    await DownloadAuditLogdata(Data);

    const key = await keyPromise
    const EncParams = await AesEncrypt(key, Id);
    try {
      const response = await api.fetch('api/TemplateCreation/GetPreviewData', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      if (!response.ok) throw new Error('Failed to fetch data');

      const result = await response.json();
      const decryptedResult = await AesDecrypt(key, result);

      const FileName = decryptedResult[0].file_name;
      const encodedContent = decryptedResult[0].encoded_doc_content;
      const templateType = decryptedResult[0].template_type;

      if (templateType === 'designer') {
        const byteCharacters = atob(encodedContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const docBlob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        saveAs(docBlob, FileName + ".docx");
        return;
      }

      const decodedText = atob(encodedContent);

      // Extract the HTML portion inside the MHT part
      const htmlMatch = decodedText.match(/Content-Location: file:\/\/\/.*?\n\n([\s\S]+?)\n------=mhtDocumentPart--/);
      const htmlContent = htmlMatch ? htmlMatch[1] : 'Unable to extract preview content';

      const transformHtmlToNewline = (htmlString: string) => {
        let cleaned = htmlString
          .replace(/&nbsp;/g, '')
          .replace(/<strong>/g, '')
          .replace(/<\/strong>/g, '')
          .replace(/&nbsp;/g, '')
          .replace(/"/g, '')
          .replace(/<ul>/g, '')
          .replace(/<\/ul>/g, '')
          .replace(/<br>/g, '')
          .replace(/<\/br>/g, '')
          .replace(/<li>/g, '')
          .replace(/<\/li>/g, '')
          .replace(/<h4>/g, '')
          .replace(/<\/h4>/g, '')
          .replace(/<p>/g, '')
          .replace(/<\/p>/g, '\n')
          .replace(/:.*/g, '');

        return cleaned
          .split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0)
          .join('\n');
      };

      const transformedContent = transformHtmlToNewline(htmlContent);
      // ✅ Generate proper .docx using docx package
      const doc = new Document({
        sections: [
          {
            children: transformedContent.split('\n').map(line =>
              new Paragraph({
                children: [new TextRun(line)],
              })
            ),
          },
        ],
      });

      const docBlob = await Packer.toBlob(doc);
      saveAs(docBlob, FileName + ".docx");

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }






  const PreviewTemplate = async (row: any) => {
    const Id = row.id;
    const Username = localStorage.UserName;
    const Name = row.file_name;
    const RefId = row.refid;
    const Data = { Username, RefId, Name };

    await DownloadAuditLogdata(Data);

    const key = await keyPromise;
    const EncParams = await AesEncrypt(key, Id);

    try {
      const response = await api.fetch('api/TemplateCreation/GetPreviewData', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      if (!response.ok) throw new Error('Failed to fetch data');
      const result = await response.json();
      const decryptedResult = await AesDecrypt(key, result);

      const FileName = decryptedResult[0].file_name;
      const encodedContent = decryptedResult[0].encoded_doc_content;
      const templateType = decryptedResult[0].template_type;

      if (templateType === 'designer') {
        const docContent = decryptedResult[0].content;
        setPreviewLayoutSchema(decryptedResult[0].layout_schema);
        setPreviewFileName(FileName);
        setPreviewContent(Array.isArray(docContent) ? docContent.join('\n') : (docContent || ''));
        setPreviewModal(true);
        return;
      }
      setPreviewLayoutSchema(null);

      const decodedText = atob(encodedContent);

      // Extract the HTML portion inside the MHT part
      const htmlMatch = decodedText.match(/Content-Location: file:\/\/\/.*?\n\n([\s\S]+?)\n------=mhtDocumentPart--/);
      const htmlContent = htmlMatch ? htmlMatch[1] : 'Unable to extract preview content';

      const transformHtmlToNewline = (htmlString: string) => {
        let cleaned = htmlString.replace(/&nbsp;/g, '')
          .replace(/<strong>/g, '')
          .replace(/<\/strong>/g, '')
          .replace(/&nbsp;/g, '')
          .replace(/"/g, '')
          .replace(/;/g, '')
          .replace(/<ul>/g, '')
          .replace(/<\/ul>/g, '')
          .replace(/<br>/g, '')
          .replace(/<\/br>/g, '')
          .replace(/<li>/g, '')
          .replace(/<\/li>/g, '')
          .replace(/<h4>/g, '')
          .replace(/<\/h4>/g, '')
          .replace(/<p>/g, '')
          .replace(/<\/p>/g, '\n')
          .replace(/:.*/g, '');

        // Trim extra spaces from each line
        cleaned = cleaned
          .split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0) // remove empty lines
          .join('\n');

        return cleaned;
      };

      const transformedContent = transformHtmlToNewline(htmlContent);

      setPreviewFileName(FileName);
      setPreviewContent(transformedContent);
      setPreviewModal(true);


    } catch (error) {
      console.error('Error:', error);
    }
  };

  const deleteTemplate = async (Id: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, Id);
    await api.fetch('api/TemplateCreation/delete', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
  };

  const DeleteAuditLogdata = async (Data: any) => {
    // const EncParams = AesEncrypt(Data);
    await api.fetch('api/TemplateCreation/deleteauditlog', {
      method: 'POST',
      body: JSON.stringify({ Data })
    });
  }


  const DeleteRow = async (rows: DeleteRowData[] | DeleteRowData) => {
    const Username = localStorage.UserName;
    // const Name = row.UserName;
    // const RefId = row.id;
    // const Data = { Username, RefId, Name };
    // const Id = row.id;
    const deleteRow = async () => {
      const rowCount = Array.isArray(rows) ? rows.length : 1;

      Swal.fire({
        title: "Insurance Verification Platform",
        text: "Are you sure do you want to delete?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ms-1",
        },
        buttonsStyling: false,
        allowOutsideClick: false
      })
        .then(async function (result) {
          if (result.isConfirmed) {
            if (Array.isArray(rows)) {
              const ids = rows.map(row => row.id);
              const Data = rows.map(row => ({
                Username,
                RefId: row.refid,
                Name: row.file_name
              }));
              await deleteTemplate(ids);
              await DeleteAuditLogdata(Data);
              setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
            } else {
              const { id, UserName: Name } = rows;
              const RefId = rows.refid
              const name = rows.file_name
              const Data = { Username, name, RefId };

              await deleteTemplate([id]);
              await DeleteAuditLogdata(Data);
              setLocalData(prev => prev.filter(item => item.id !== id));
            }
            // await deleteTemplate(Id);
            fetchData()
            Swal.fire({
              icon: "success",
              title: "Insurance Verification Platform",
              text: "Template has been deleted.",
              customClass: {
                confirmButton: "btn btn-success",
              },
              allowOutsideClick: false
            });
            // fetchData();
            handleReloadTable()
          }
        });
    };
    deleteRow();
  };


  const filteredData = data.filter(row => {
    return Object.values(row).some(val =>
      typeof val === "string" && val.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
  }
  // Handle individual row checkbox change
  const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
    ({ id, ...props }, ref) => (
      <div style={{ position: 'relative', left: '10px' }}>
        <input type='checkbox' id={id} ref={ref} {...props} />
      </div>
    )
  );

  const handleChangecheck = useCallback(
    ({ selectedRows }: any) => {

      const selectedEventIds = [];
      selectedRows.forEach((row: any) => {
        selectedEventIds.push(row.id);
      });
      setEventId(selectedRows)
      setEventId1(selectedEventIds.length)
      if (!action.fromUser)
        return;
      selectedRowsPerPage[currentPage] = selectedRows;
    }, [currentPage, selectedRowsPerPage, action.fromUser]
  );

  const CustomLoadingComponent = () => {
    return (
      <div className="">
        {store.no_Data === 'There is no Record Found' ? (
          <h4>
            <br />
            <p>There are no records to display</p>
          </h4>
        ) : (
          <div className="custom-loader">
            <label className="custom-label">Please wait...</label>
            <div className="custom-loading"></div>
          </div>
        )}
      </div>
    );
  };



  const Columns = [
    {
      name: usertype === "MOS" ? 'Client Name' : 'User Name',
      selector: (row: DeleteRowData) => row.ClientName,
      sortable: true,
    },
    {
      name: "File Name",
      selector: (row: DeleteRowData) => row.file_name,
      sortable: true,
    },
    {
      name: "Created By",
      selector: (row: DeleteRowData) => row.User_Name,
      sortable: true,
    },
    {
      name: "Created Date",
      // selector: (row: DeleteRowData) => row.content_time,
      selector: (row: DeleteRowData) => {
        return row.content_time
          ? moment.utc(row.content_time)
            .tz(moment.tz.guess())
            .format('MM/DD/YYYY, HH:mm:ss')
          : 'NA';
      },
      sortable: true,
    },
    {
      name: "Action",
      cell: (row: DeleteRowData) => (
        <>
          <>
            <Eye
              size={17}
              color='#09d5ff'
              id='audit'
              onClick={() => {
                setScrollInnerModal(true);
                setRefid(row.refid);
              }}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
            <UncontrolledTooltip placement="top" target='audit' style={{ backgroundColor: "#355876", color: "white" }}>
              Audit log
            </UncontrolledTooltip>
          </>
          <FileText
            size={17}
            color='#e49a38'
            id='positionRight'
            onClick={() => { PreviewTemplate(row) }}
            style={{ cursor: 'pointer', marginRight: '10px' }}
          />
          <UncontrolledTooltip placement="top" target='positionRight' style={{ backgroundColor: "#355876", color: "white" }}>
            Preview
          </UncontrolledTooltip>
          <Download
            size={17}
            id='positionLeft'
            color='rgb(53 88 116)'
            onClick={() => { DownloadTemplate(row) }}
            style={{ cursor: 'pointer', marginRight: '10px' }}
          />
          <UncontrolledTooltip placement='top' target='positionLeft' style={{ backgroundColor: "#355876", color: "white" }}>
            Download Template In Word
          </UncontrolledTooltip>
          <Edit
            size={17}
            color='#FFA500'
            onClick={() => {
              navigate(
                activeTab === 'form'
                  ? `/templateCreation/formDesigner/${row.id}`
                  : `/templateCreation/EditTemplate/${row.id}`
              )
            }}
            style={{ cursor: 'pointer', marginRight: '10px' }}
          />
          {eventId1 === 0 && (
            menuActions.includes("delete") && (
              <>
                <Trash2
                  size={17}
                  id='Delete'
                  color='#FF0000'
                  onClick={() => { DeleteRow(row) }}
                  style={{ cursor: 'pointer' }}
                />
                <UncontrolledTooltip placement='top' target='Delete' style={{ backgroundColor: "#355876", color: "white" }}>
                  Delete
                </UncontrolledTooltip>
              </>
            )
          )}
        </>
      ),
    },
  ];
  const customStyles = {
    rows: {
      style: {
        '&:hover': {
          backgroundColor: '#f0f0f0',

        },
      },
    },
    headCells: {
      style: {
        backgroundColor: '#355876',  // Change background color of headers
        color: 'white',  // Change text color of headers
        fontSize: '16px',  // Adjust font size of headers
      },
    },
  };

  const startIndex = (currentPage - 1) * rowsPerPage + 1;
  const endIndex = Math.min(currentPage * rowsPerPage, store.total);



  return (
    <>
      <Breadcrumbs mainTitle='Template Creation' title='Template Creation' />
      <Container fluid>
        <Row >
          <Col sm={12}>
            <br />
            <Card >
              <Modal style={{ maxWidth: '1500px', maxHeight: '600px' }} isOpen={scrollInnerModal} toggle={() => setScrollInnerModal(!scrollInnerModal)} className='modal-dialog-centered modal-lg'>
                <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>Template creation  Audit Log</ModalHeader>
                <ModalBody>
                  <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                          <th className="audit-tableHeaderStyle">Date & Time</th>
                          <th className="audit-tableHeaderStyle">Action</th>
                          <th className="audit-tableHeaderStyle">Data Set</th>
                          <th className="audit-tableHeaderStyle">Changed By</th>
                        </tr>
                      </thead>
                      <tbody style={{ alignItems: 'center' }}>
                        {filteredAuditData &&
                          filteredAuditData
                            .sort((a: any, b: any) => new Date(b.Modified).getTime() - new Date(a.Modified).getTime())
                            .map((item: any, index: number) => (
                              <tr key={index}>
                                <td className="audit-tableDataStyle">
                                  {(() => {
                                    const localDate = moment.utc(item.Modified).local().format('MM/DD/YYYY hh:mm:ss A');
                                    return localDate;
                                  })()}
                                </td>
                                <td className="audit-tableDataStyle">{item.Action}</td>
                                <td className="audit-tableDataStyle">
                                  {item.Action === 'VIEW' ? (
                                    <span>{item.JsonData}</span>
                                  ) : item.Action === 'DOWNLOAD' ? (
                                    <span>{item.JsonData}</span>
                                  ) : (
                                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                      <thead>
                                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                                          <th className="audit-tableHeaderStyle">Field</th>
                                          {(item.Action === 'ADD' || item.Action === 'EDIT') && (
                                            <th className="audit-tableHeaderStyle">Value</th>
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.JsonData
                                          .sort((a: any, b: any) => a.field.localeCompare(b.field))
                                          .map((dataItem: any, dataIndex: number) => (
                                            <tr key={dataIndex}>
                                              <td className="audit-tableDataStyle">{dataItem.field}</td>

                                              {(item.Action === 'ADD' || item.Action === 'EDIT') && (
                                                <td className="audit-tableDataStyle">
                                                  {dataItem.field === 'Password' || dataItem.field === 'Pin' ? (
                                                    '******'
                                                  ) : dataItem.field === 'Permission' && Array.isArray(dataItem.value) ? (
                                                    <table style={{ width: '100%' }}>
                                                      <thead>
                                                        <tr>
                                                          <th className="audit-tableHeaderStyle">Menu</th>
                                                          <th className="audit-tableHeaderStyle">Actions</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                      </tbody>
                                                    </table>
                                                  ) : dataItem.field === 'KEYS' && Array.isArray(dataItem.value) ? (
                                                    // Iterate over KEYS array and display each value one by one
                                                    <div>
                                                      {dataItem.value.map((keyValue: string, keyIndex: number) => (
                                                        <div key={keyIndex}>{keyValue}</div>
                                                      ))}
                                                    </div>
                                                  ) : (
                                                    (dataItem.value && dataItem.value.value) || dataItem.value
                                                  )}
                                                </td>
                                              )}
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  )}
                                </td>
                                <td className="audit-tableDataStyle">{item.UserName}</td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                </ModalBody>
              </Modal>
              <Nav tabs className="px-3 pt-3">
                <NavItem>
                  <NavLink
                    active={activeTab === 'document'}
                    onClick={() => handleTabChange('document')}
                    style={{ cursor: 'pointer' }}
                  >
                    Create New Template
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    active={activeTab === 'form'}
                    onClick={() => handleTabChange('form')}
                    style={{ cursor: 'pointer' }}
                  >
                    Create Form Template
                  </NavLink>
                </NavItem>
              </Nav>
              <CardBody>
                <div className="table-responsive">
                  <div className="dataTables_wrapper">

                    <DataTable
                      key={activeTab}
                      persistTableHead
                      subHeader={true}
                      responsive={true}
                      onSort={handleSort}
                      data={dataToRender()}
                      columns={Columns}
                      paginationServer
                      customStyles={customStyles}
                      paginationPerPage={rowsPerPage}
                      paginationDefaultPage={currentPage}
                      // clearSelectedRows={loading}
                      selectableRows
                      selectableRowsHighlight
                      selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                      onSelectedRowsChange={handleChangecheck}
                      paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                      noDataComponent={<CustomLoadingComponent />}
                      paginationComponent={CustomPagination}
                      subHeaderComponent={
                        <CustomHeader
                          value={value}
                          menuActions={menuActions}
                          rowsPerPage={rowsPerPage}
                          handleFilter={handleFilter}
                          handlePerPage={handlePerPage}
                          activeTab={activeTab}

                        />
                      }
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ paddingLeft: '2%' }}>
                        {store.total && (
                          <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                        )}
                      </div>
                      <div>
                        <CustomPagination />
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>

            <Modal
              isOpen={previewModal}
              toggle={() => setPreviewModal(!previewModal)}
              size="xl"
              className="modal-dialog-scrollable"
              style={{ maxWidth: '90%' }}
            >
              <ModalHeader toggle={() => setPreviewModal(!previewModal)}>
                Preview: {previewFileName}
              </ModalHeader>
              <ModalBody style={{ maxHeight: '75vh', overflowY: 'auto', backgroundColor: '#eaeaea', padding: '20px' }}>
                {previewLayoutSchema ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '25px' }}>
                    {previewLayoutSchema.pages?.map((page: any, pageIdx: number) => {
                      const pageSize = previewLayoutSchema.pageSize || 'Letter';
                      const orientation = previewLayoutSchema.orientation || 'portrait';
                      const PAGE_SIZE_PX: Record<string, { width: number; height: number }> = {
                        Letter: { width: 816, height: 1056 },
                        A4: { width: 794, height: 1123 }
                      };
                      const base = PAGE_SIZE_PX[pageSize] || { width: 816, height: 1056 };
                      const pageWidth = orientation === 'landscape' ? base.height : base.width;
                      const pageHeight = orientation === 'landscape' ? base.width : base.height;

                      return (
                        <div
                          key={pageIdx}
                          style={{
                            width: pageWidth,
                            height: pageHeight,
                            position: 'relative',
                            background: '#fff',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                            boxSizing: 'border-box',
                            overflow: 'hidden'
                          }}
                        >
                          {page.elements?.map((el: any) => {
                            if (!el.visible || el.type === 'rect') return null;

                            const s = el.style || {};
                            const wrapperStyle: React.CSSProperties = {
                              position: 'absolute',
                              left: el.x,
                              top: el.y,
                              width: el.width,
                              height: el.height,
                              transform: el.rotation ? `rotate(${el.rotation}deg)` : undefined,
                              background: s.background && s.background !== 'transparent' ? s.background : undefined,
                              borderWidth: s.borderWidth || 0,
                              borderStyle: s.borderStyle && s.borderStyle !== 'none' ? s.borderStyle : undefined,
                              borderColor: s.borderColor,
                              borderRadius: s.borderRadius,
                              padding: s.padding,
                              boxSizing: 'border-box',
                              // Match the designer canvas: labels/checkboxes/radios must never be clipped by a
                              // box that is a few px narrower than their text.
                              overflow: ['text', 'label', 'heading', 'paragraph', 'rect', 'checkbox', 'radio'].includes(el.type) ? 'visible' : 'hidden',
                              userSelect: 'none',
                            };

                            const elementBodyStyle = {
                              fontFamily: s.fontFamily,
                              fontSize: s.fontSize,
                              fontWeight: s.fontWeight,
                              fontStyle: s.fontStyle,
                              textDecoration: s.textDecoration,
                              color: s.color,
                              textAlign: s.textAlign,
                              lineHeight: s.lineHeight,
                            };

                            let body: React.ReactNode = null;
                            switch (el.type) {
                              case 'heading':
                              case 'label':
                              case 'paragraph':
                              case 'pagenumber':
                                body = (
                                  <div style={{ ...elementBodyStyle, width: '100%', height: '100%', whiteSpace: 'pre-wrap' }}>
                                    {(el.content || []).map((run: any, runIdx: number) =>
                                      run.type === 'variable' ? run.fieldKey : run.value
                                    )}
                                  </div>
                                );
                                break;
                              case 'text': {
                                // Single-line field-value content: the box is sized for the short real
                                // answer, not the longer "$fieldKey$" placeholder shown pre-fill, so shrink
                                // the font to keep the full text visible instead of ellipsis-truncating it.
                                const textDisplay = (el.content || [])
                                  .map((run: any) => (run.type === 'variable' ? run.fieldKey : run.value))
                                  .join('');
                                const textFitSize = fitPreviewFontSize(textDisplay, s.fontSize || 12, (el.width || 0) - 6, s.fontFamily);
                                body = (
                                  <div style={{ ...elementBodyStyle, fontSize: textFitSize, width: '100%', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                    {textDisplay}
                                  </div>
                                );
                                break;
                              }
                              case 'hline':
                                body = <div style={{ width: '100%', height: 0, borderTop: `${s.borderWidth || 1}px ${s.borderStyle || 'solid'} ${s.borderColor || '#000'}` }} />;
                                break;
                              case 'vline':
                                body = <div style={{ width: 0, height: '100%', borderLeft: `${s.borderWidth || 1}px ${s.borderStyle || 'solid'} ${s.borderColor || '#000'}` }} />;
                                break;
                              case 'checkbox':
                                body = (
                                  <label style={{ ...elementBodyStyle, display: 'flex', alignItems: 'center', gap: '0.15em', height: '100%', margin: 0, whiteSpace: 'nowrap' }}>
                                    <input type="checkbox" readOnly style={{ width: '0.75em', height: '0.75em', margin: 0, flexShrink: 0 }} checked={!!el.typeProps?.checkbox?.checked} />
                                    {el.typeProps?.checkbox?.label}
                                  </label>
                                );
                                break;
                              case 'radio':
                                body = (
                                  <label style={{ ...elementBodyStyle, display: 'flex', alignItems: 'center', gap: '0.15em', height: '100%', margin: 0, whiteSpace: 'nowrap' }}>
                                    <input type="radio" readOnly style={{ width: '0.75em', height: '0.75em', margin: 0, flexShrink: 0 }} checked={!!el.typeProps?.radio?.checked} />
                                    {el.typeProps?.radio?.label}
                                  </label>
                                );
                                break;
                              case 'dropdown':
                                body = (
                                  <select style={{ ...elementBodyStyle, width: '100%', height: '100%' }} disabled>
                                    {(el.typeProps?.dropdown?.options || []).map((o: any, idx: number) => (
                                      <option key={idx}>{o}</option>
                                    ))}
                                  </select>
                                );
                                break;
                              case 'textbox': {
                                const disp = el.bindings?.dynamicField || (el.bindings?.defaultValue || '');
                                const boxFitSize = fitPreviewFontSize(disp, s.fontSize || 12, (el.width || 0) - 8, s.fontFamily);
                                body = <input style={{ ...elementBodyStyle, fontSize: boxFitSize, width: '100%', height: '100%', border: 'none', background: 'transparent' }} readOnly placeholder={disp} />;
                                break;
                              }
                              case 'textarea': {
                                const disp = el.bindings?.dynamicField || (el.bindings?.defaultValue || '');
                                body = <textarea style={{ ...elementBodyStyle, width: '100%', height: '100%', border: 'none', background: 'transparent', resize: 'none' }} readOnly value={disp} />;
                                break;
                              }
                              case 'date': {
                                const disp = el.bindings?.dynamicField || 'MM/DD/YYYY';
                                const dateFitSize = fitPreviewFontSize(disp, s.fontSize || 12, (el.width || 0) - 8, s.fontFamily);
                                body = <input style={{ ...elementBodyStyle, fontSize: dateFitSize, width: '100%', height: '100%', border: 'none', background: 'transparent' }} readOnly placeholder={disp} />;
                                break;
                              }
                              case 'signature':
                                body = (
                                  <div style={{ ...elementBodyStyle, width: '100%', height: '100%', borderBottom: '1px solid #000', display: 'flex', alignItems: 'flex-end', color: '#999' }}>
                                    {el.typeProps?.signature?.placeholderText || 'Signature'}
                                  </div>
                                );
                                break;
                              case 'image':
                                body = el.typeProps?.image?.src ? (
                                  <img src={el.typeProps.image.src} alt="" style={{ width: '100%', height: '100%', objectFit: el.typeProps?.image?.fit || 'contain' }} />
                                ) : (
                                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: 12, background: '#f8f9fb', border: '1px dashed #ccc' }}>Image</div>
                                );
                                break;
                              case 'table': {
                                const t = el.typeProps?.table;
                                if (!t) break;
                                const covered = new Set<string>();
                                t.merges.forEach((m: any) => {
                                  for (let r = m.r; r < m.r + m.rowSpan; r++) {
                                    for (let c = m.c; c < m.c + m.colSpan; c++) {
                                      if (r === m.r && c === m.c) continue;
                                      covered.add(`${r}_${c}`);
                                    }
                                  }
                                });

                                body = (
                                  <table style={{ width: '100%', height: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                    <tbody>
                                      {Array.from({ length: t.rows }, (_, r) => (
                                        <tr key={r} style={{ height: t.rowHeights[r] || 'auto' }}>
                                          {Array.from({ length: t.cols }, (_, c) => {
                                            const key = `${r}_${c}`;
                                            if (covered.has(key)) return null;
                                            const merge = t.merges.find((m: any) => m.r === r && m.c === c);
                                            return (
                                              <td
                                                key={c}
                                                rowSpan={merge?.rowSpan || 1}
                                                colSpan={merge?.colSpan || 1}
                                                style={{
                                                  border: '1px solid #999',
                                                  padding: 4,
                                                  width: `${t.colWidths[c] || 100 / t.cols}%`,
                                                  verticalAlign: 'middle',
                                                  fontSize: 12,
                                                }}
                                              >
                                                {(t.cells?.[r]?.[c] || []).map((run: any, runIdx: number) =>
                                                  run.type === 'variable' ? run.fieldKey : run.value
                                                )}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                );
                                break;
                              }
                            }

                            return (
                              <div key={el.id} style={wrapperStyle}>
                                {body}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
                    {previewContent}
                  </pre>
                )}
              </ModalBody>
            </Modal>
            <div>
              {eventId1 > 0 && menuActions.includes('delete') && (
                <div className="customizer-links open">
                  <Nav className=" flex-column nav-pills">
                    <a className="nav-link" onClick={() => DeleteRow(eventId)}>
                      <span>Delete</span>
                      <Trash2 className="trash-icon" size={20} />
                    </a>
                  </Nav>
                </div>
              )}
            </div>
          </Col>
        </Row >
      </Container >
    </>

  );
};
export default TemplateCreationWithForm;